import { CSSObject } from "styled-components";
import { ACTIVE_SCROLLBAR_BORDER_WIDTH_VALUE } from "./cssObjectForActiveScrollbar";
import { ColorHex, Unit } from "../../../../../../../types/globals";

export default function cssObjectForScrollbarPart(
	backgroundColor: ColorHex,
	borderRadius: Unit
): CSSObject {
	return {
		border: `${ACTIVE_SCROLLBAR_BORDER_WIDTH_VALUE + 1}px solid transparent`,
		backgroundClip: "padding-box",
		borderRadius: borderRadius,
		backgroundColor: backgroundColor as string,
	};
}
